import { useState, useEffect } from "react";
import { Promotion } from "@/interface/promotion";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";
import { updateCartPromotion } from "@/store/slices/cartSlice";

const usePromoCodes = () => {
	const location = useSelector((state: AppState) => state.location);
	const cart = useSelector((state: AppState) => state.cart);
	const groupCart = useSelector((state: AppState) => state.group_cart);
	const activeCart = groupCart?.allowShopping === true;
	const dispatch = useDispatch();

	const fetchPromoCodes = async () => {
		if (!location?.activeLocation?.id) {
			return;
		}
		try {
			const response = await axios.get(
				`${process.env.NEXT_PUBLIC_BASE_URL}/api/promotions/code/public`,
				{ params: { branchId: location.activeLocation.id } }
			);
			return response.data.data;
		} catch (err: any) {
			return [];
		}
	};
	const applyPromo = async (
		input: string,
		setCouponResponse: React.Dispatch<
			React.SetStateAction<{
				error: boolean;
				success: boolean;
				errorMessage: string;
			}>
		>
	) => {
		if (!location?.activeLocation?.id) {
			return;
		}

		const availablePromos: Promotion[] = await fetchPromoCodes();
		if (availablePromos.length === 0) {
			return;
		}

		const matchedPromo = availablePromos.find(promo => promo.code === input);

		if (matchedPromo) {
			try {
				const response = await axios.post(
					`${process.env.NEXT_PUBLIC_BASE_URL}/api/cart/apply-promotion`,
					{
						cartId: activeCart ? groupCart?.id : cart?.id,
						promoCode: matchedPromo.code,
						branchId: location.activeLocation.id,
					}
				);
				dispatch(
					updateCartPromotion({
						id: response.data.result.id,
						totalPrice: response.data.result.totalPrice,
						discountedPrice: response.data.result.discountedPrice,
						items: response.data.result.items,
						applied_promo_code: response.data.result.applied_promo_code,
						initialPrice: response.data.result.initialPrice,
					})
				);
			} catch (err: any) {
				setCouponResponse(prev => ({
					...prev,
					error: true,
					errorMessage:
						err.response?.data?.error ||
						"An error occurred. Please try again.",
				}));
			}
		} else {
			setCouponResponse(prev => ({
				...prev,
				error: true,
				errorMessage: "Invalid coupon for this location",
			}));
		}
	};
	const removePromo = async (promoCode: string) => {
		if (!location?.activeLocation?.id) {
			return;
		}
		try {
			const response = await axios.post(
				`${process.env.NEXT_PUBLIC_BASE_URL}/api/cart/remove-promotion`,
				{
					cartId: activeCart ? groupCart?.id : cart?.id,
					promoCode: promoCode,
					branchId: location.activeLocation.id,
				}
			);
			dispatch(
				updateCartPromotion({
					id: response.data.result.id,
					totalPrice: response.data.result.totalPrice,
					discountedPrice: response.data.result.discountedPrice,
					items: response.data.result.items,
					applied_promo_code: response.data.result.applied_promo_code,
					initialPrice: 0,
				})
			);
		} catch (err) {}
	};

	return {
		fetchPromoCodes,
		applyPromo,
		removePromo,
	};
};

export default usePromoCodes;
